import React, { useState, useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const Login = () => {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const serverUrl = process.env.REACT_APP_SERVER_URL || 'http://localhost:5000';

    try {
      const res = await fetch(`${serverUrl}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message || 'System verification mismatch error execution path.');
      
      login(data.user, data.token);
      navigate('/');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B0F19] text-white flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-[#151D30] rounded-2xl p-8 border border-gray-800 shadow-2xl">
        <h2 className="text-3xl font-bold text-center tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-purple-500">Welcome Back</h2>
        <p className="text-center text-xs text-gray-400 mt-1">Authenticate access verification to connect back into streaming panels.</p>

        {error && <div className="mt-4 p-3 bg-red-500/10 border border-red-500 text-red-500 text-xs rounded-xl text-center">{error}</div>}

        <form onSubmit={handleFormSubmit} className="mt-6 space-y-4">
          <div>
            <label className="block text-xs font-semibold text-gray-400 mb-1.5 uppercase tracking-wider">Email Address</label>
            <input 
              type="email" 
              required
              value={formData.email}
              onChange={e => setFormData({ ...formData, email: e.target.value })}
              className="w-full px-4 py-2.5 rounded-xl text-sm bg-[#0B0F19] border border-gray-700 text-white outline-none focus:border-accentBlue transition-colors"
            />
          </div>

          <div>
            <label className="block text-xs font-semibold text-gray-400 mb-1.5 uppercase tracking-wider">Account Password</label>
            <input 
              type="password" 
              required
              value={formData.password}
              onChange={e => setFormData({ ...formData, password: e.target.value })}
              className="w-full px-4 py-2.5 rounded-xl text-sm bg-[#0B0F19] border border-gray-700 text-white outline-none focus:border-accentBlue transition-colors"
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            className="w-full mt-2 py-3 bg-gradient-to-r from-accentBlue to-accentViolet text-white font-bold text-sm rounded-xl transition-transform transform active:scale-95 shadow-md disabled:opacity-50"
          >
            {loading ? 'Authenticating Data...' : 'Sign In Now'}
          </button>
        </form>

        <p className="mt-6 text-center text-xs text-gray-400">
          New profile node needed? <Link to="/register" className="text-accentBlue hover:underline font-medium">Create user directory entry here</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;